import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, Transition as _Transition, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a907820"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "validationPopup__header" }
const _hoisted_2 = { class: "validationPopup__headerDescription" }
const _hoisted_3 = { style: {"display":"flex","flex-direction":"column"} }
const _hoisted_4 = { style: {"display":"flex"} }
const _hoisted_5 = { class: "validationPopup__headerDescription" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_8 = { class: "validationPopup__body" }
const _hoisted_9 = { class: "validationPopup__description" }
const _hoisted_10 = {
  key: 0,
  class: "validationPopup__description"
}
const _hoisted_11 = { class: "field-local" }
const _hoisted_12 = { class: "invalid-feedback" }
const _hoisted_13 = { class: "validationPopup__description" }
const _hoisted_14 = { class: "field" }
const _hoisted_15 = { class: "validationPopup__btn" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "C4E", -1 /* HOISTED */))
const _hoisted_18 = { class: "invalid-feedback" }
const _hoisted_19 = {
  key: 0,
  class: "validationPopup__reservationReq"
}
const _hoisted_20 = {
  key: 0,
  class: "validationPopup__btnHolder"
}
const _hoisted_21 = { class: "validationPopup__btns" }
const _hoisted_22 = {
  key: 1,
  class: "validationPopup__btns"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode($setup["Dialog"], {
      visible: $props.visible,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ($setup.emit('close'))),
      modal: "",
      header: " ",
      style: { width: '800px', 'z-index':'1000' }
    }, {
      default: _withCtx(() => [
        ($setup.loginPopupStatus)
          ? (_openBlock(), _createBlock($setup["LoginPopUp"], {
              key: 0,
              showAddressOption: false,
              onClose: _cache[0] || (_cache[0] = ($event: any) => ($setup.loginPopupStatus =! $setup.loginPopupStatus))
            }))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode($setup["ValidatorLogo"], {
              validator: $props.validator,
              class: "validator-image-big"
            }, null, 8 /* PROPS */, ["validator"]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h2", null, _toDisplayString($props.validator.description.moniker), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("p", null, _toDisplayString(_ctx.$t('STAKING_VIEW.STAKING_POPUP.COMMISSION')) + " -", 1 /* TEXT */),
                _createVNode($setup["PercentsView"], {
                  amount: $props.validator.commission.rate,
                  precision: 2
                }, null, 8 /* PROPS */, ["amount"])
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_Icon, { name: "Globe" }),
              _createElementVNode("a", {
                href: $props.validator.description.website,
                target: "_blank"
              }, _toDisplayString(_ctx.$t('STAKING_VIEW.STAKING_POPUP.WEBSITE')), 9 /* TEXT, PROPS */, _hoisted_6)
            ])
          ]),
          _createCommentVNode("        <Button icon=\"pi pi-times\" style=\"width: 10px; margin-bottom: 0.5rem\" @click=\"$emit('close')\" class=\"p-button-rounded p-button-secondary p-button-text\"/>")
        ]),
        _createElementVNode("div", _hoisted_7, [
          ($setup.stakingAction === $setup.StakingAction.DELEGATE)
            ? (_openBlock(), _createBlock($setup["WarningMessage"], {
                key: 0,
                header: "STAKING_VIEW.STAKING_POPUP.WARNINGS.DELEGATIONS.HEADER",
                "header-variables": {timeToComplete: $setup.timeToComplete},
                texts: "STAKING_VIEW.STAKING_POPUP.WARNINGS.DELEGATIONS.TEXT",
                "texts-variables": {timeToComplete: $setup.timeToComplete}
              }, null, 8 /* PROPS */, ["header-variables", "texts-variables"]))
            : ($setup.stakingAction === $setup.StakingAction.UNDELEGATE)
              ? (_openBlock(), _createBlock($setup["WarningMessage"], {
                  key: 1,
                  header: "STAKING_VIEW.STAKING_POPUP.WARNINGS.UNDELEGATIONS.HEADER",
                  "header-variables": {timeToComplete: $setup.timeToComplete},
                  texts: "STAKING_VIEW.STAKING_POPUP.WARNINGS.UNDELEGATIONS.TEXTS",
                  "texts-variables": {timeToComplete: $setup.timeToComplete}
                }, null, 8 /* PROPS */, ["header-variables", "texts-variables"]))
              : _createCommentVNode("v-if", true)
        ]),
        _createVNode($setup["Form"], {
          onSubmit: $setup.action,
          "validation-schema": $setup.baseSchema,
          class: "validationPopup__body",
          as: "form"
        }, {
          default: _withCtx(({ errors }) => [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t('STAKING_VIEW.STAKING_POPUP.HEADER')), 1 /* TEXT */),
              _createCommentVNode("<div class=\"validationPopup__description\">\n            <div class=\"validationPopup__descriptionIcon\">\n              <Icon name=\"Globe\"></Icon>\n            </div>\n            <div class=\"validationPopup__description-info\">\n              <p>{{ $t('COMMON.DESCRIPTION') }}</p>\n              <p>{{ $t('COMMON.THE') }} {{validator.description.moniker}} {{ $t('STAKING_VIEW.STAKING_POPUP.VALIDATOR_DESCRIPTION') }}</p>\n              <a :href=\"validator.description.website\">{{validator.description.website}}</a>\n            </div>\n          </div>"),
              _createVNode($setup["AmountView"], {
                class: "validationPopup__amount",
                coins: $setup.amountToPass,
                "show-denom": true,
                precision: 4,
                "orig-denom": $setup.useConfigurationStore().config.getConvertedDenom(),
                "reduce-big-number": false
              }, {
                "logo-front": _withCtx(() => [
                  _createVNode($setup["C4EIcon"], {
                    icon: "c4e-circle",
                    size: "30"
                  })
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["coins", "orig-denom"]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode($setup["StakingActionVue"], {
                  modelValue: $setup.stakingAction,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.stakingAction) = $event)),
                  disabled: !$setup.canModify,
                  "redelegation-direction": $props.redelegationDirection
                }, null, 8 /* PROPS */, ["modelValue", "disabled", "redelegation-direction"])
              ]),
              ($setup.stakingAction === $setup.StakingAction.REDELEGATE)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode($setup["Field"], {
                        modelValue: $setup.redelegateValidator,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.redelegateValidator) = $event)),
                        placeholder: " ",
                        name: "redelegateValidator"
                      }, {
                        default: _withCtx(({ field, handleChange }) => [
                          _createVNode($setup["StakingRedelegate"], {
                            validator: $props.validator,
                            "onUpdate:modelValue": handleChange,
                            "model-value": field.value,
                            class: _normalizeClass({ 'p-invalid': errors.redelegateValidator, 'is-invalid': errors.redelegateValidator }),
                            disabled: !$setup.canModify,
                            "redelegation-direction": $props.redelegationDirection
                          }, null, 8 /* PROPS */, ["validator", "onUpdate:modelValue", "model-value", "class", "disabled", "redelegation-direction"])
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue"]),
                      _createCommentVNode(" <span>{{getRedelagatePlaceholder(redelegationDirection)}}</span> "),
                      _createElementVNode("div", _hoisted_12, _toDisplayString(errors.redelegateValidator ? errors.redelegateValidator : ""), 1 /* TEXT */)
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createVNode($setup["Field"], {
                    modelValue: $setup.amount,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.amount) = $event)),
                    name: "amount",
                    placeholder: " ",
                    type: "number",
                    class: _normalizeClass(["form-control", { 'is-invalid': errors.amount }]),
                    style: {"width":"100%"},
                    disabled: !$setup.canModify
                  }, null, 8 /* PROPS */, ["modelValue", "class", "disabled"]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('COMMON.INPUT.AMOUNT')), 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("button", {
                      type: "button",
                      disabled: !$setup.canModify,
                      onClick: $setup.transferAllAmount
                    }, "Max", 8 /* PROPS */, _hoisted_16),
                    _hoisted_17
                  ]),
                  _createCommentVNode("              <p style=\"text-align: left\">"),
                  _createCommentVNode("                commission ~ {{commissionForOperation.toFixed(2)}} c4e"),
                  _createCommentVNode("              </p>"),
                  _createElementVNode("div", _hoisted_18, _toDisplayString(errors.amount ? errors.amount : ""), 1 /* TEXT */),
                  _createVNode(_Transition, { name: "slide-fade" }, {
                    default: _withCtx(() => [
                      ($setup.showReserveCheckbox)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.reserveCoins) = $event))
                            }, null, 512 /* NEED_PATCH */), [
                              [_vModelCheckbox, $setup.reserveCoins]
                            ]),
                            _createElementVNode("p", null, "Reserve " + _toDisplayString($setup.fee + $setup.reservedCoins) + " C4E for future transactions", 1 /* TEXT */)
                          ]))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                  })
                ])
              ])
            ]),
            ($setup.canModify)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    ($setup.stakingAction === $setup.StakingAction.DELEGATE)
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 0,
                          class: "validationPopup__button",
                          type: "submit"
                        }, {
                          default: _withCtx(() => [
                            _createVNode($setup["StakeManagementIcon"], { icon: "delegate" }),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('STAKING_VIEW.STAKING_POPUP.DELEGATE')), 1 /* TEXT */)
                          ]),
                          _: 1 /* STABLE */
                        }))
                      : _createCommentVNode("v-if", true),
                    ($setup.stakingAction === $setup.StakingAction.UNDELEGATE)
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 1,
                          class: "validationPopup__button",
                          type: "submit"
                        }, {
                          default: _withCtx(() => [
                            _createVNode($setup["StakeManagementIcon"], { icon: "undelegate" }),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('STAKING_VIEW.STAKING_POPUP.UNDELEGATE')), 1 /* TEXT */)
                          ]),
                          _: 1 /* STABLE */
                        }))
                      : _createCommentVNode("v-if", true),
                    ($setup.stakingAction === $setup.StakingAction.REDELEGATE)
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 2,
                          class: "validationPopup__button",
                          type: "submit"
                        }, {
                          default: _withCtx(() => [
                            _createVNode($setup["StakeManagementIcon"], { icon: "redelegate" }),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('STAKING_VIEW.STAKING_POPUP.REDELEGATE')), 1 /* TEXT */)
                          ]),
                          _: 1 /* STABLE */
                        }))
                      : _createCommentVNode("v-if", true)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createTextVNode(_toDisplayString(_ctx.$t('ERRORS.CONNECT_WALLET')) + " ", 1 /* TEXT */),
                  (!$setup.useUserStore().isLoggedIn)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        class: "secondary",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.loginPopupStatus =! $setup.loginPopupStatus))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('COMMON.CONNECT')), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      }))
                    : _createCommentVNode("v-if", true)
                ]))
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["validation-schema"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["visible"])
  ]))
}